// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2LCTk","signatureButtonsRight":"ModalSign_signatureButtonsRight__3d5dC"};